// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__wNbun","video":"styles_video__32uJf"};